module.exports = __webpack_public_path__ + "img/2.c06c7191.jpg";